import { render } from "./ForgotPassword.vue?vue&type=template&id=7c60a1ee&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "@/styles/ForgotPassword.css?vue&type=style&index=0&id=7c60a1ee&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c60a1ee"]])

export default __exports__